import {buildAppQueries} from '../../../libs/shared/core/src/services/query/appQueryHelpers';
import {VacationResponderSearchOptions} from '../../../src/models/api/vacationResponderModel';
import {fetchVacationResponderAsync, fetchVacationRespondersAsync} from './helpers/api';

export interface VacationResponderQuerySearchOptions
  extends Omit<VacationResponderSearchOptions, 'limit' | 'offset'> {}

export const vacationResponderQueries = buildAppQueries('vacationResponder', {
  byId: (id: number) => ({
    queryKey: {id},
    queryFn: async ({company, cancelToken}) => fetchVacationResponderAsync(company.url, id, cancelToken),
  }),
  byNamespace: (namespace: string) => ({
    queryKey: {namespace},
    queryFn: async ({company, cancelToken}) =>
      fetchVacationRespondersAsync(company.url, namespace, cancelToken),
  }),
  twoByNamespace: (namespace: string) => ({
    queryKey: {namespace},
    queryFn: async ({company, cancelToken}) =>
      fetchVacationRespondersAsync(company.url, namespace, cancelToken, {limit: 2}),
  }),
  search: (searchOptions: VacationResponderQuerySearchOptions) => ({
    queryKey: searchOptions,
  }),
});
